import React, { useCallback, useEffect, useState } from "react";
import SettingList from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier";
import { MockSetAnalytic, getAnalyticsConfiguration } from "./setting-analytic.type";
import { useSettingsDraft } from "../../../../../context-controller-mod/context-serv/global-provider/setting-context/settings-draft.context";

const PAGE_KEY = "analytics";

const AnalyticsSet = () => {
  const { getToggle, setToggle, hydrateMany } = useSettingsDraft();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;

    const run = async () => {
      try {
        setLoading(true);
        const res = await getAnalyticsConfiguration();
        if (!alive) return;

        const widget = res.data.data.settings?.widget;

        hydrateMany({
          pageKey: PAGE_KEY,
          toggles: [
            { groupId: 1, itemId: 1, value: !!widget?.content?.enabled },
            { groupId: 1, itemId: 2, value: !!widget?.media?.enabled },
            { groupId: 1, itemId: 3, value: !!widget?.jobApplication?.enabled },
            { groupId: 1, itemId: 4, value: !!widget?.inbox?.enabled },
          ],
        });
      } catch (e) {
        console.error("GET analytics-configuration failed:", e);
      } finally {
        if (alive) setLoading(false);
      }
    };

    run();
    return () => {
      alive = false;
    };
  }, [hydrateMany]);

  const isChecked = useCallback(
    (groupId: number, itemId: number) => getToggle(PAGE_KEY, groupId, itemId),
    [getToggle]
  );

  const onToggle = useCallback(
    (payload: {
      groupId: number;
      groupTitle: string;
      itemId: number;
      itemTitle: string;
      checked: boolean;
    }) => {
      setToggle({
        pageKey: PAGE_KEY,
        groupId: payload.groupId,
        groupTitle: payload.groupTitle,
        itemId: payload.itemId,
        itemTitle: payload.itemTitle,
        value: payload.checked,
      });
    },
    [setToggle]
  );

  return (
    <main>
      {MockSetAnalytic.map((group) => (
          <SettingList
            key={group.id}
            groupId={group.id}
            mainTitle={group.title}
            paragraph={group.description}
            setList={group.items}
            isChecked={isChecked}
            onToggle={onToggle}
          />
        ))
      }
    </main>
  );
};

export default AnalyticsSet;